var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[(_vm.discussion && _vm.discussion.length > 0)?_c('p',[_vm._v("Discussion module")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }